export default { //组件和点击按钮时能触发的效果
	"pipeline": [
		{
			name: '消失',
			value: 'pipeline-disappear'
		},
		{
			name: '显示',
			value: 'pipeline-appear'
		},
		{
			name: '开关',
			value: 'pipeline-toggle'  // 对应 EventActionHandlesMap.vue
		},
		{
			name: '停止',
			value: 'pipeline-stop'
		},
		{
			name: '启动',
			value: 'pipeline-start'
		},
	],
	"rectangle": [
		{
			name: '闪烁',
			value: 'rectangle-flash'
		},
		{
			name: '停止闪烁',
			value: 'rectangle-stopFlash'
		},
		{
			name: '消失',
			value: 'rectangle-disappear'
		},
		{
			name: '显示',
			value: 'rectangle-appear'
		},
	],
	"circle": [
		{
			name: '闪烁',
			value: 'circle-flash'
		},
		{
			name: '停止闪烁',
			value: 'circle-stopFlash'
		},
		{
			name: '消失',
			value: 'circle-disappear'
		},
		{
			name: '显示',
			value: 'circle-appear'
		},
	],
	"arrow": [
		{
			name: '闪烁',
			value: 'arrow-flash'
		},
		{
			name: '停止闪烁',
			value: 'arrow-stopFlash'
		},
		{
			name: '消失',
			value: 'arrow-disappear'
		},
		{
			name: '显示',
			value: 'arrow-appear'
		},
	],
	"triangle": [
		{
			name: '闪烁',
			value: 'triangle-flash'
		},
		{
			name: '停止闪烁',
			value: 'triangle-stopFlash'
		},
		{
			name: '消失',
			value: 'triangle-disappear'
		},
		{
			name: '显示',
			value: 'triangle-appear'
		},
	],
	"wheel": [
		{
			name: '消失',
			value: 'wheel-disappear'
		},
		{
			name: '显示',
			value: 'wheel-appear'
		},
		{
			name: '顺时针旋转',
			value: 'wheel-clockWise'
		},
		{
			name: '停止旋转',
			value: 'wheel-stop'
		}
	],
	"staticLabel":[
		{
			name: '消失',
			value: 'staticLabel-disappear'
		},
		{
			name: '显示',
			value: 'staticLabel-appear'
		},
	],
	"dynamicLabel":[
		{
			name: '消失',
			value: 'dynamicLabel-disappear'
		},
		{
			name: '显示',
			value: 'dynamicLabel-appear'
		},
	],
	"img":[
		{
			name: '消失',
			value: 'img-disappear'
		},
		{
			name: '显示',
			value: 'img-appear'
		},
	],
	// "button":[
	// 	{
	// 		name: '页面切换',
	// 		value: 'page-change'
	// 	},
	// ]
	
}